import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ChildModule } from "src/app/models/childModule";
import { Module } from "src/app/models/module";
import { Tenant } from "src/app/models/tenant";
import { Modules, SpaRoutingService, isModule, sidebarMode } from "src/app/shared/services/spa.routing.service";
import { ConfigurationAccessService } from "src/app/configuration/configuration-access.service";
import { CONFIGURATION_OVERVIEW, ConfigurationGroupSections, ConfigurationSection } from "src/app/configuration/configuration-registry";
import { ThirdPartyApp } from "src/app/links/links-registry";
import { ThirdPartyAppLauncherService } from "src/app/links/third-party-app-launcher.service";

@Component({
    selector: 'app-nav-drawer',
    templateUrl: './nav-drawer.component.html',
    styleUrls: ['./nav-drawer.component.css'],
    standalone: false
})

export class NavDrawerComponent implements OnInit {
  @Input() currentModule: Module;
  @Input() currentChildModule: ChildModule;
  @Input() headerItems: Module[];
  @Input() configModule: Module;
  @Input() profileModule: Module;
  @Input() notificationModule: Module;
  @Input() thirdPartyApps: ThirdPartyApp[] = [];
  @Input() tenant: Tenant;
  @Input() accessibleTenants: Tenant[] = [];
  @Output() navigate$ = new EventEmitter<([any, Module])>();
  @Output() logout$ = new EventEmitter<Event>();
  @Output() switchTenant$ = new EventEmitter<Tenant>();

  readonly configOverview = CONFIGURATION_OVERVIEW;
  configGroups: ConfigurationGroupSections[] = [];
  activeSectionKey: string | null = null;

  constructor(
    private router: Router,
    private configAccess: ConfigurationAccessService,
    private appLauncher: ThirdPartyAppLauncherService,
    private spaRoutingService: SpaRoutingService) {
  }

  ngOnInit(): void {
    this.configGroups = this.configModule ? this.configAccess.visibleGroupSections() : [];
    this.activeSectionKey = this.configAccess.activeSectionKey(this.router.routerState.snapshot.root);
  }

  get configActive(): boolean {
    return isModule(this.currentModule, Modules.CONFIGURATION);
  }

  launchThirdPartyApp(event: Event, app: ThirdPartyApp): void {
    event.stopPropagation();
    this.appLauncher.launch(app);
  }

  hasChildren(item: Module): boolean {
    return sidebarMode(item) === 'children';
  }

  processChildClick(event: Event, selectedItem: any, parentItem: Module): void {
    event.stopPropagation();
    this.navigate$.emit([selectedItem, parentItem]);
  }

  // Navigates directly; DrawerService closes the drawer on NavigationStart.
  configSectionClick(event: Event, section: ConfigurationSection): void {
    event.stopPropagation();
    this.spaRoutingService.navigateToConfigurationSection(section.path);
  }

  logoutClicked($event: Event) {
    this.logout$.emit($event);
  }

  tenantSelected(tenant: Tenant): void {
    this.switchTenant$.emit(tenant);
  }
}
